import {Box, Card, Checkbox, Modal, Text} from '@mantine/core';
import {useEffect} from 'react';
import {MdPersonAdd} from 'react-icons/md';

type Props = {
  scoutPopup: boolean;
  closePopup: () => void;
  checked: boolean;
  setChecked: (value: boolean) => void;
};

export const ScoutPopup: React.FC<Props> = ({
  scoutPopup,
  closePopup,
  checked,
  setChecked,
}) => {
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'imp_scout_popup');
    }
  }, []);

  const onPressScoutLink = () => {
    window.open('/scouts', '_blank');
    window.gtag('event', 'click_scout_popup', {link: '/scouts'});
  };

  return (
    <Modal
      opened={scoutPopup}
      onClose={closePopup}
      className="mx-auto my-auto z-50 overflow-x-hidden overflow-y-auto"
      size="350px"
      withCloseButton={false}
      onClick={(e) => {
        e.stopPropagation();
      }}
      centered
    >
      <Card className="p-16 flex flex-col justify-center mx-auto gap-y-16">
        <Box className="text-primary mx-auto">
          <MdPersonAdd size={48} />
        </Box>
        <Text className="text-md text-center">フォローが完了しました!</Text>
        <Text className="text-black-2 text-base text-center">
          フォローをするとフォローした企業からスカウトが届く確率も高まります。
          <br />
          <span
            className="text-primary cursor-pointer"
            onClick={onPressScoutLink}
          >
            スカウトトップ
          </span>
          からプロフィールを充実させることで、あなたの魅力を企業にアピールしましょう！
        </Text>
        <Text
          className="text-primary-2 text-base text-center cursor-pointer"
          onClick={closePopup}
        >
          閉じる
        </Text>
        <Checkbox
          checked={checked}
          onChange={() => {
            setChecked(!checked);
          }}
          label="しばらくこのメッセージを表示しない"
        />
      </Card>
    </Modal>
  );
};
